import { makeStyles } from 'tss-react/mui';

export const styles = makeStyles()(() => {
  return {
    container: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '16px',
      margin: '16px 40px 16px 40px'
    },
    card: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
      minWidth: '160px',
      flex: 1,
      padding: '16px',
      borderRadius: '10px',
      backgroundColor: '#FFFFFF',
      border: '1px solid #E0E0E0'
    },
    retry: {
      alignSelf: 'center',
      background: 'none',
      border: 'none',
      color: '#017E4A',
      cursor: 'pointer',
      textDecoration: 'underline'
    }
  };
});
